import { render, staticRenderFns } from "./YearsSelection.vue?vue&type=template&id=6fa5b4b8&scoped=true"
import script from "./YearsSelection.vue?vue&type=script&lang=js"
export * from "./YearsSelection.vue?vue&type=script&lang=js"
import style0 from "./YearsSelection.vue?vue&type=style&index=0&id=6fa5b4b8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa5b4b8",
  null
  
)

export default component.exports